import {BaseException} from './base-exception';

export class CouldNotConnectToServerException extends BaseException {
    constructor() {
        super(
            'Network.CouldNotConnectToServer',
            'Could not connect to server, please try again.'
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/server-communications/exceptions/could-not-connect-to-server.ts